// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3fLe4","vLegacy":"SelectSecondary_vLegacy__sGMmz","error":"SelectSecondary_error__79oCq","disabled":"SelectSecondary_disabled__1OVS6"};